<template>
  <div class="empty-text-wrap">
    <i>
      <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
        <path d="M3 15.2381V11.619C3 10.6592 3.3728 9.7387 4.03639 9.05999C4.69998 8.38129 5.6 8 6.53846 8H18.3326C19.0979 8.00194 19.8423 8.25572 20.4557 8.72381L27.0615 13.7905C27.2474 13.9331 27.404 14.1117 27.5224 14.3162C27.6408 14.5206 27.7186 14.7469 27.7514 14.9822C27.7843 15.2174 27.7715 15.457 27.7139 15.6872C27.6562 15.9174 27.5548 16.1337 27.4154 16.3238C27.276 16.5139 27.1013 16.6741 26.9014 16.7951C26.7015 16.9162 26.4802 16.9958 26.2502 17.0294C26.0202 17.063 25.786 17.05 25.5609 16.991C25.3358 16.932 25.1243 16.8283 24.9385 16.6857L18.3326 11.619H6.53846V15.2381C6.53846 15.718 6.35206 16.1783 6.02027 16.5176C5.68847 16.857 5.23846 17.0476 4.76923 17.0476C4.3 17.0476 3.84999 16.857 3.5182 16.5176C3.1864 16.1783 3 15.718 3 15.2381ZM17.1538 42.381H6.53846V40.5714C6.53846 40.0915 6.35206 39.6313 6.02027 39.2919C5.68847 38.9525 5.23846 38.7619 4.76923 38.7619C4.3 38.7619 3.84999 38.9525 3.5182 39.2919C3.1864 39.6313 3 40.0915 3 40.5714V42.5212C3.00117 43.4435 3.3599 44.3276 3.99752 44.9798C4.63515 45.6319 5.49961 45.9988 6.40135 46H17.1538C17.6231 46 18.0731 45.8094 18.4049 45.47C18.7367 45.1307 18.9231 44.6704 18.9231 44.1905C18.9231 43.7106 18.7367 43.2503 18.4049 42.9109C18.0731 42.5716 17.6231 42.381 17.1538 42.381ZM33.0769 42.381H26C25.5308 42.381 25.0808 42.5716 24.749 42.9109C24.4172 43.2503 24.2308 43.7106 24.2308 44.1905C24.2308 44.6704 24.4172 45.1307 24.749 45.47C25.0808 45.8094 25.5308 46 26 46H33.0769C33.5462 46 33.9962 45.8094 34.328 45.47C34.6598 45.1307 34.8462 44.6704 34.8462 44.1905C34.8462 43.7106 34.6598 43.2503 34.328 42.9109C33.9962 42.5716 33.5462 42.381 33.0769 42.381ZM47.2308 29.7143C46.7615 29.7143 46.3115 29.9049 45.9797 30.2443C45.6479 30.5836 45.4615 31.0439 45.4615 31.5238V42.381H41.9231C41.4538 42.381 41.0038 42.5716 40.672 42.9109C40.3402 43.2503 40.1538 43.7106 40.1538 44.1905C40.1538 44.6704 40.3402 45.1307 40.672 45.47C41.0038 45.8094 41.4538 46 41.9231 46H45.6584C46.5443 45.9988 47.3935 45.6383 48.02 44.9976C48.6464 44.357 48.9988 43.4883 49 42.5823V31.5238C49 31.0439 48.8136 30.5836 48.4818 30.2443C48.15 29.9049 47.7 29.7143 47.2308 29.7143ZM45.4615 13.4286H34.8462C34.3769 13.4286 33.9269 13.6192 33.5951 13.9586C33.2633 14.2979 33.0769 14.7582 33.0769 15.2381C33.0769 15.718 33.2633 16.1783 33.5951 16.5176C33.9269 16.857 34.3769 17.0476 34.8462 17.0476H45.4615V22.4762C45.4615 22.9561 45.6479 23.4164 45.9797 23.7557C46.3115 24.0951 46.7615 24.2857 47.2308 24.2857C47.7 24.2857 48.15 24.0951 48.4818 23.7557C48.8136 23.4164 49 22.9561 49 22.4762V17.0476C49 16.0878 48.6272 15.1673 47.9636 14.4886C47.3 13.8099 46.4 13.4286 45.4615 13.4286ZM4.76923 33.3333C5.23846 33.3333 5.68847 33.1427 6.02027 32.8033C6.35206 32.464 6.53846 32.0037 6.53846 31.5238V24.2857C6.53846 23.8058 6.35206 23.3455 6.02027 23.0062C5.68847 22.6668 5.23846 22.4762 4.76923 22.4762C4.3 22.4762 3.84999 22.6668 3.5182 23.0062C3.1864 23.3455 3 23.8058 3 24.2857V31.5238C3 32.0037 3.1864 32.464 3.5182 32.8033C3.84999 33.1427 4.3 33.3333 4.76923 33.3333Z" fill="#EAEAEA"/>
      </svg>
    </i>
    <span class="empty-txt" :style="{ marginTop: textMarginTop }">{{text}}</span>
  </div>

</template>
<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: "EmptyText",
  components: {

  },
  props: {
    text:{
      type:String,
    },
    textMarginTop:{
      type:String,
      default: '12px'
    }
  },
  setup() {

  }
});
</script>
<style lang="scss">
.empty-text-wrap{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width:100%;
  height: 100%;
  .empty-txt{
    margin-top: 12px;
    color:#A4A4A4;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%; /* 21px */
    letter-spacing: -0.28px;
  }
}
</style>